(function () {
  'use strict';

  var ATTR_SESSION_ID   = 'quiz_funnel_session_id';
  var ATTR_VARIANT      = 'quiz_variant';
  var ATTR_COMPLETED_AT = 'quiz_completed_at';

  /* ─────────────────────────────────────────────
     Local-storage helpers
  ───────────────────────────────────────────── */
  function readStorage(key) {
    try { return localStorage.getItem(key) || null; } catch (e) { return null; }
  }

  /* ─────────────────────────────────────────────
     Build the quiz attribute payload from storage.
     Returns null if there is nothing worth attaching.
  ───────────────────────────────────────────── */
  function buildQuizAttributes() {
    // Active session (quiz in progress) or completed session (quiz done)
    var sessionId   = readStorage('qf_session_id') || readStorage('qf_completed_session_id');
    var variant     = readStorage('qf_variant');
    var completedAt = readStorage('qf_completed_at');

    console.log('[QuizCartSync] localStorage:', { qf_session_id: sessionId, qf_variant: variant, qf_completed_at: completedAt });

    if (!sessionId) {
      console.log('[QuizCartSync] No session ID found — skipping cart update');
      return null;
    }

    var attrs = {};
    attrs[ATTR_SESSION_ID] = sessionId;
    if (variant)     attrs[ATTR_VARIANT]      = variant;
    if (completedAt) attrs[ATTR_COMPLETED_AT] = completedAt;
    return attrs;
  }

  /* ─────────────────────────────────────────────
     getCart()
     Fetches the current Shopify cart via AJAX API.
     Returns a Promise resolving to the cart object.
  ───────────────────────────────────────────── */
  function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* ─────────────────────────────────────────────
     mergeAttributes(existingAttributes, quizAttributes)
     Returns a merged object, only setting quiz keys
     that are missing or outdated in the cart.
     Never overwrites non-quiz keys.
  ───────────────────────────────────────────── */
  function mergeAttributes(existingAttributes, quizAttributes) {
    var merged = {};

    // Preserve all existing attributes as-is
    var existing = existingAttributes || {};
    var keys = Object.keys(existing);
    for (var i = 0; i < keys.length; i++) {
      merged[keys[i]] = existing[keys[i]];
    }

    // Only set quiz attributes that are absent or have changed
    var quizKeys = Object.keys(quizAttributes);
    var needsUpdate = false;
    for (var j = 0; j < quizKeys.length; j++) {
      var k = quizKeys[j];
      if (merged[k] !== quizAttributes[k]) {
        merged[k] = quizAttributes[k];
        needsUpdate = true;
      }
    }

    return needsUpdate ? merged : null;
  }

  /* ─────────────────────────────────────────────
     updateCartAttributes(attributes)
     POSTs the full merged attributes object to /cart/update.js.
     Returns a Promise resolving to the updated cart object.
  ───────────────────────────────────────────── */
  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* ─────────────────────────────────────────────
     attachQuizAttributesToCart()
     Full pipeline: read quiz data → get cart →
     merge → update (only if something changed).
     Returns a Promise.
  ───────────────────────────────────────────── */
  function attachQuizAttributesToCart() {
    var quizAttrs = buildQuizAttributes();
    if (!quizAttrs) return Promise.resolve(null);

    return getCart().then(function (cart) {
      if (!cart) { console.log('[QuizCartSync] Could not fetch cart'); return null; }

      console.log('[QuizCartSync] Current cart attributes:', cart.attributes);

      var merged = mergeAttributes(cart.attributes, quizAttrs);
      if (!merged) { console.log('[QuizCartSync] Already up-to-date, no update needed'); return null; }

      console.log('[QuizCartSync] Updating cart with:', merged);
      return updateCartAttributes(merged).then(function (result) {
        console.log('[QuizCartSync] Cart updated successfully:', result && result.attributes);
        return result;
      });
    }).catch(function (err) { console.error('[QuizCartSync] Error:', err); return null; });
  }

  /* ─────────────────────────────────────────────
     initQuizCartSync()
     - Runs attachQuizAttributesToCart() immediately
       (covers cases where items are already in the cart).
     - Intercepts all add-to-cart form submissions and
       runs the sync before the form proceeds.
  ───────────────────────────────────────────── */
  function initQuizCartSync() {
    console.log('[QuizCartSync] Initializing on:', window.location.href);
    // Eager sync on page load
    attachQuizAttributesToCart();

    // Intercept all add-to-cart forms
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('form[action="/cart/add"]')) return;

      // Only intercept if we have quiz data to attach
      var quizAttrs = buildQuizAttributes();
      if (!quizAttrs) return;

      // Prevent the submit, sync, then re-submit
      e.preventDefault();
      e.stopImmediatePropagation();

      attachQuizAttributesToCart().then(function () {
        // Re-submit natively — avoids double-intercept by cloning and submitting the form
        var clone = document.createElement('form');
        clone.method  = form.method  || 'POST';
        clone.action  = form.action;
        clone.enctype = form.enctype || 'multipart/form-data';
        clone.style.display = 'none';

        // Copy all inputs
        var inputs = form.querySelectorAll('input, select, textarea, button[type="submit"]');
        for (var i = 0; i < inputs.length; i++) {
          var el = inputs[i];
          var hidden = document.createElement('input');
          hidden.type  = 'hidden';
          hidden.name  = el.name;
          hidden.value = el.tagName === 'SELECT'
            ? el.options[el.selectedIndex].value
            : el.value;
          if (hidden.name) clone.appendChild(hidden);
        }

        document.body.appendChild(clone);
        clone.submit();
        document.body.removeChild(clone);
      }).catch(function () {
        // Sync failed — submit original form anyway to not block purchase
        form.submit();
      });
    }, true /* capture — runs before theme JS handlers */);

    // Also intercept Shopify AJAX add-to-cart (fetch / XHR based themes)
    // by patching fetch globally for /cart/add calls
    var _originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1) {
        return attachQuizAttributesToCart().then(function () {
          return _originalFetch.call(window, input, init);
        }).catch(function () {
          return _originalFetch.call(window, input, init);
        });
      }
      return _originalFetch.call(window, input, init);
    };
  }

  /* ─────────────────────────────────────────────
     Bootstrap — run after DOM is ready
  ───────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizCartSync);
  } else {
    initQuizCartSync();
  }

  // Expose public API for manual calls (e.g. from quiz completion handler)
  window.QuizCartSync = {
    attach: attachQuizAttributesToCart,
    getCart: getCart,
    mergeAttributes: mergeAttributes,
    updateCartAttributes: updateCartAttributes,
  };
})();
